<template>
  <div style="padding: 0 10px">
    <ScanQuery @onQuery="queryCall" ph="输入快递单号/采购单号" />
    <!-- <el-descriptions border direction="vertical" :title="`待入库：采购单号 ${packageInfo.purchaseNo}`">
      <el-descriptions-item label="供应商名称">
        {{ packageInfo.shopName }}
      </el-descriptions-item>
      <el-descriptions-item label="订单来源">
        {{
            packageInfo.pkgType < 0 ? "----" : packageTypeStr[packageInfo.systemSource]
        }} </el-descriptions-item>
          <el-descriptions-item label="采购单类型">
            {{
                packageInfo.purchaseType == 0
                  ? packageInfo.bizType == 1
                    ? "档口采购单"
                    : packageInfo.bizType == 2
                      ? "线上采购单"
                      : "普通采购单"
                  : packageInfo.purchaseType == 1
                    ? "OEM大货单"
                    : packageInfo.purchaseType == 2
                      ? "OEM样品单"
                      : "-"
            }}
          </el-descriptions-item>
          <el-descriptions-item label="采购单创建时间">
            {{ packageInfo.purchaseCreateTime || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="运单号维护时间">
            {{
                (packageInfo.logisticsNumberList && packageInfo.logisticsNumberList.length > 0 &&
                  packageInfo.logisticsNumberList[
                    packageInfo.logisticsNumberList.length - 1
                  ].createTime) ||
                "-"
            }}
          </el-descriptions-item>
    </el-descriptions> -->
    <!--    采购单 start-->
    <!--    采购单 start-->
    <!--    采购单 start-->
    <WmsTable :columns="columns" isExpanded :is-pagination="false" @pageChange="pageChangeCall"
      :dataSource="dataSource">
      <!-- <template slot="title">
        <header class="title__header" style="margin-right: auto">
          <strong>
            <span style="margin-right: 30px">采购单创建时间：{{ packageInfo.createdTime }}</span>
          </strong>
        </header>
      </template> -->
      <ImgPreviews slot="productImgActive" slot-scope="{ text, record, index }" :images="[text]" />
      <template slot="productName" slot-scope="{ text, record, index }">
        <div @click="toProductLink(record)" style="color:#008dde;white-space:pre-wrap">{{ text }}</div>
      </template>
      <template slot="checkAction" slot-scope="{ text, record, index }">
        <div class="check__div--action">
          <IptNumber unit="件" v-model="record.warehousingAmount" :max="record.num" />
          <el-checkbox v-model="record.isPrint">一键打印</el-checkbox>
          <el-button type="primary" @click="printMonad(record)">
            入库
          </el-button>
        </div>
      </template>
      <div slot="expandedRender" slot-scope="{ record }">
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <strong> 异常处理 </strong>
            </template>
            <AbnormalSubmit :record="record" ref="check_AbnormalSubmit" @DoStockIn="getDataSource" />
            <DefectiveSubmit :record="record" ref="check_DefectiveSubmit" @DoStockIn="getDataSource" />
          </el-collapse-item>
        </el-collapse>
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <strong> 操作记录 </strong>
            </template>
            <template>
              <div v-for="(item, index) in record.stockInDTOList" :key="index" class="table-s">
                <div class="title">已入库批次:</div>
                <div>
                  运单号：{{ item.expressNo }} 入库时间：{{ item.createTime }}
                </div>
                <WmsTable :is-pagination="false" :columns="operateColumns"
                  :dataSource="item.pkgList ? item.pkgList : []">
                  <div slot="printAction" slot-scope="{ text, record, index }" style="
                      display: flex;
                      justify-content: flex-start;
                      align-items: center;
                    ">
                    <IptNumber unit="件" v-model="record.printNum" />
                    <el-button type="primary" @click="operatePrint(record)">
                      打印</el-button>
                  </div>
                  <div slot="productSku" slot-scope="{ text, record, index }" style="
                      display: flex;
                      justify-content: flex-start;
                      align-items: center;
                    ">
                    <input type="text" v-model="text" />
                  </div>
                </WmsTable>
              </div>
            </template>
            <!-- <WmsTable :is-pagination="false" :columns="operateColumns" :dataSource="record.stockInDTOList ? record.stockInDTOList : []">
              <template slot="productImgActive" slot-scope="{text, record, index}">
                <ImgPreviews :images="[record.pkgList[0].productImg]" />
              </template>
              <div slot="printAction" slot-scope="{ text, record, index }" style="display: flex; justify-content: flex-start; align-items: center">
                <IptNumber unit="件" v-model="record.amount"/>
                <el-button type="primary" @click="operatePrint"> 打印</el-button>
              </div>
              <div slot="productSku" slot-scope="{ text, record, index }" style="display: flex; justify-content: flex-start; align-items: center">
                <input type="text" v-model="text" />
              </div>
            </WmsTable> -->
          </el-collapse-item>
        </el-collapse>
        <!--    操作记录 end-->
        <!--    操作记录 end-->
        <!--    操作记录 end-->
      </div>
    </WmsTable>
    <!--    采购单 end-->
    <!--    采购单 end-->
    <!--    采购单 end-->
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import WmsTable from "@/components/WmsTable";
import ImgPreviews from "@/components/ImgPreviews";
import IptNumber from "@/components/IptNumber";
import AbnormalSubmit from "@/views/inHouse/components/Abnormal/AbnormalSubmit";
import DefectiveSubmit from "@/views/inHouse/components/Abnormal/DefectiveSubmit";
import { packageTypeStr } from "@/types";
import { Descriptions } from "ant-design-vue";
import { audioPay } from "@/utils/tools";
import { templatePrintByPkg } from "@/utils/print";
import {
  checkColumns,
  testCheckDataSource,
  checkOperateColumns,
  testOperateDataSource,
} from "./checkData";
import { inHouseDoStockIn, inHouseQuery } from "@/apis/inHouse";
import { selectSpecialCheckInfo, getAdditionalItemsInfo } from "@/apis/checking";

export default {
  name: "Check",
  components: {
    [Descriptions.name]: Descriptions,
    [Descriptions.Item.name]: Descriptions.Item,
    DefectiveSubmit,
    AbnormalSubmit,
    ImgPreviews,
    IptNumber,
    ScanQuery,
    WmsTable
  },
  data() {
    return {
      query: {
        code: "",
        // current: 1,
        // pageSize: 10,
        // total: 0
      },
      packageTypeStr,
      packageInfo: {
        purchaseNo: "----",
        systemSource: -1,
        shopName: "----",
        createdTime: "----",
      },
      columns: checkColumns,
      operateColumns: checkOperateColumns,
      dataSource: [],
      operateDataSource: [],
      printTemplate: "",
    };
  },
  mounted() {
    // getPkgTemplate().then(({ code, data }) => {
    //   if (code === 0) {
    //     this.printTemplate = data.templateJson
    //   }
    // })
  },
  watch: {
    $route: {
      handler: function (newVal, oldVal) {
        if (newVal.query.purchaseNew) {
          this.query.code = newVal.query.purchaseNew;
          this.getDataSource();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    queryCall: function (payload) {
      // console.log(payload)
      this.query.code = payload.code;
      this.getDataSource();
    },
    pageChangeCall: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
      };
      // console.log(this.query)
    },
    //
    resetPage: function () {
      this.query = {
        ...this.query,
        current: 1,
        pageSize: 10,
        total: 0,
      };
      this.packageInfo = {
        purchaseNo: "----",
        systemSource: -1,
        shopName: "----",
        createdTime: "----",
      };
      this.dataSource = [];
      this.operateDataSource = [];
    },
    getDataSource: function () {
      // TODO
      const that = this;
      that.resetPage();
      const { code } = that.query;
      if (!(code && code !== "")) {
        audioPay(`请输入快递单号`);
        return;
      }
      inHouseQuery({ expressNo: code.trim() }).then(({ code, data }) => {
        if (code === 0) {
          const {
            createdTime,
            purchaseNo,
            systemSource,
            shopName,
            productDTOList,
          } = data;
          const purchaseType = data.purchaseType;
          productDTOList.forEach(il1 => {
            if (il1.stockInDTOList) {
              il1.stockInDTOList.forEach(il2 => {
                if (il2.pkgList) {
                  il2.pkgList.forEach(il3 => {
                    il3.printNum = il3.amount
                  })
                }
              })
            }
          });
          // let protest = [...productDTOList,...productDTOList,...productDTOList,...productDTOList,...productDTOList,...productDTOList,...productDTOList,...productDTOList,...productDTOList,...productDTOList,...productDTOList,]
          that.dataSource = productDTOList.map((item) => {
            return {
              ...item,
              expressNo: that.query.code,
              warehousingAmount: item.num,
              isPrint: true,
              purchaseType: purchaseType,
            };
          });
          that.packageInfo = {
            // purchaseNo,
            // systemSource,
            // shopName,
            // createdTime,
            ...data,
          };
          if (1) {
            // todo 待后端完善参数
            audioPay(`扫描完成`);
          } else {
            audioPay(`采购单缺失`);
          }
        }
      });
    },
    // 入库单按钮
    printMonad: function (r) {
      const {
        isPrint,
        expressNo,
        warehousingAmount,
        productSku,
        purchaseNo,
        purchaseType,
        operationType = 0,
        relationRespDTOList,
        inboundCode
      } = r;
      let orderCode
      if (relationRespDTOList.length && relationRespDTOList[0].orderNo) {
        orderCode = relationRespDTOList[0].orderNo
      }else{
        this.$message.warning("订单号缺失，请联系技术人员");
      }
      const params = {
        expressNo,
        productSku,
        purchaseNo, purchaseType,
        operationType: 1, // 1正常 2次品 3 异常上报客户 4 异常上报采购
        amount: warehousingAmount,
        orderCode: orderCode,
        inboundCode:inboundCode
      };
      if (warehousingAmount == 0 || !warehousingAmount) {
        this.$message.warning("入库数量必须大于0");
        return;
      }
      inHouseDoStockIn(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("入库成功");
          this.$wmsPrint.print().templatePrintByPkg([data[0]])
          // getAdditionalItemsInfo({ systemOrderNo: data[0].orderCode }).then(res => {
          //   if (res.code === 0) {
          //     let Additional = ''
          //     res.data.forEach(item => {
          //       if (item.additionName) {
          //         Additional += ',' + item.additionName
          //       }
          //     })
          //     Additional = Additional.slice(1)
          //     if (isPrint) {
          //       let Arr = [];
          //       Arr.push({ ...data[0], additional: Additional })
          //       // this.$refs.choosePrintDialog.templatePrintByPkg(Arr)
          //     }
          //   }
          // })
          // selectSpecialCheckInfo({ systemOrderNo: data[0].orderCode }).then(res => {
          //   if (res.code === 0) {
          //     if (isPrint) {
          //       let Arr = [];
          //       // for (let i = 0; i < data[0].amount; i++) {
          //       //   Arr.push({ ...data[0], specialCheckRequirement: res.data.specialCheckRequirement});
          //       // }
          //       Arr.push({ ...data[0], specialCheckRequirement: res.data.specialCheckRequirement })
          //       templatePrintByPkg(Arr);
          //     }
          //   }
          // })
          this.getDataSource();
        }
      });
    },
    // 操作记录打印
    operatePrint: function (record) {
      // if (record.orderCode) {
      //   console.log('orderCode')
      //   // selectSpecialCheckInfo({ systemOrderNo: record.orderCode }).then(res => {
      //   //   if (res.code === 0) {
      //   //     let Arr = [];
      //   //     for (let i = 0; i < record.printNum; i++) {
      //   //       Arr.push({ ...record, specialCheckRequirement: res.data.specialCheckRequirement });
      //   //     }
      //   //     // templatePrintByPkg(Arr);
      //   //     this.$refs.choosePrintDialog.templatePrintByPkg(Arr)
      //   //   }
      //   // })
      //   getAdditionalItemsInfo({ systemOrderNo: record.orderCode }).then(({ code, data }) => {
      //     if (code === 0) {
      //       let Additional = ''
      //       data.forEach(item => {
      //         if (item.additionName) {
      //           Additional += (',' + item.additionName)
      //         }
      //       })
      //       Additional = Additional.slice(1)
      //       let Arr = [];
      //       for (let i = 0; i < record.printNum; i++) {
      //         Arr.push({ ...record, additional: Additional });
      //       }
      //       this.$refs.choosePrintDialog.templatePrintByPkg(Arr)
      //     }
      //   })
      // } else {
      //   let Arr = [];
      //   for (let i = 0; i < record.printNum; i++) {
      //     Arr.push({ ...record });
      //   }
      //   this.$refs.choosePrintDialog.templatePrintByPkg(Arr)
      //   // templatePrintByPkg(Arr);
      // }
      
      this.$wmsPrint.print().templatePrintByPkg([{...record,wantPrintNum:record.printNum}])
    },
    toProductLink(record) {
      window.open(record.productLink)
    }
  },
};
</script>
<style lang="less" scoped>
.title__header {
  height: 20px;
  margin: 0;
  line-height: 20px;
}

.title__header>strong {
  font-size: 18px;
}

.check__div--action {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-s {
  padding: 20px;

  .title {
    font-size: 18px;
    font-weight: 800;
  }
}
</style>
